import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close menu on route change
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Lock body scroll when menu open
  useEffect(() => {
    if (open) document.body.classList.add("menu-open");
    else document.body.classList.remove("menu-open");
    return () => document.body.classList.remove("menu-open");
  }, [open]);

  return (
    <>
      <a className="skip-link" href="#main">Skip to content</a>
      <nav className={`nav ${scrolled ? "nav--scrolled" : ""}`}>
        <div className="nav-inner">
          <Link to="/" className="nav-logo" aria-label="Sutranode home">
            <Logo />
            <span className="logo-name">Sutranode</span>
          </Link>

          <div className="nav-links">
            <NavLink to="/work" className={({ isActive }) => (isActive ? "nav-active" : "")}>Work</NavLink>
            <NavLink to="/services" className={({ isActive }) => (isActive ? "nav-active" : "")}>Services</NavLink>
            <NavLink to="/about" className={({ isActive }) => (isActive ? "nav-active" : "")}>About</NavLink>
            <NavLink to="/contact" className={({ isActive }) => (isActive ? "nav-active" : "")}>Contact</NavLink>
            <Link to="/contact" className="nav-cta">Start a Project</Link>
          </div>

          <button
            className={`hamburger ${open ? "active" : ""}`}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      <div className={`nav-mobile-shell ${open ? "is-open" : ""}`} onClick={() => setOpen(false)}>
        <div className={`nav-mobile ${open ? "is-open" : ""}`} onClick={(e) => e.stopPropagation()}>
          <span className="nav-mobile-label">Navigate</span>
          <NavLink to="/work" className={({ isActive }) => (isActive ? "nav-active" : "")}>Work</NavLink>
          <NavLink to="/services" className={({ isActive }) => (isActive ? "nav-active" : "")}>Services</NavLink>
          <NavLink to="/about" className={({ isActive }) => (isActive ? "nav-active" : "")}>About</NavLink>
          <NavLink to="/contact" className={({ isActive }) => (isActive ? "nav-active" : "")}>Contact</NavLink>
          <Link to="/contact" className="ml-cta">Start a Project</Link>
        </div>
      </div>
    </>
  );
}

function Logo() {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <defs>
        <linearGradient id="navlg" x1="0" y1="0" x2="28" y2="28">
          <stop offset="0" stopColor="#00e5ff" />
          <stop offset=".5" stopColor="#a78bfa" />
          <stop offset="1" stopColor="#ff5ec4" />
        </linearGradient>
      </defs>
      <circle cx="14" cy="14" r="12" stroke="url(#navlg)" strokeWidth="1.4" opacity="0.5" />
      <path d="M5 5 L23 23 M23 5 L5 23" stroke="url(#navlg)" strokeWidth="2" strokeLinecap="round" />
      <circle cx="14" cy="14" r="2.4" fill="url(#navlg)" />
    </svg>
  );
}
